import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import profileSettingsTooltip from '@/modules/base-module/profile/components/ProfileSettingsTooltip.vue'
import { registeredTabsHandlers } from '@/global/components/view-layouts/tabs-layout/common/registered-tabs-handlers'
import { isFunction } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoCreateConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          post: {
            module: 'administration',
            route: 'partner-locations',
            method: 'post'
          }
        },
        modifyDataBeforeSend: (event) => this.onModifyDataBeforeSend(event),
        afterSave: () => this.backToMainTable(),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('administration/partner_location.new_location_details'),
            showBackButton: {
              onGoBack: () => {
                // exit from create mode to main table
                this.createMode = false
              }
            },
            onCancelTabSave: () => this.backToMainTable(false)
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 4,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('administration/partner_location.name'),
                    placeholder: this.$t('administration/partner_location.enter_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'partner_id',
                    label: this.$t('administration/partner.partner'),
                    placeholder: this.$t('administration/partner_location.choose_partner'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partners/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('administration/address_type.type'),
                    placeholder: this.$t('administration/partner_location.choose_location_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'address-types/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'address',
                    label: this.$t('administration/partner_location.address'),
                    placeholder: this.$t('administration/partner_location.enter_address'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'country_id',
                    label: this.$t('locations.country'),
                    placeholder: this.$t('administration/partner.select_country'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'countries/autocomplete'
                    },
                    onChange: (event) => this.onCountrySelect(event, 'form'),
                    creatable: false,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'city_id',
                    label: this.$t('locations.city'),
                    placeholder: this.$t('administration/partner.select_city'),
                    type: 'autocomplete',
                    items: this.formCitiesData.data,
                    tooltip: {
                      component: profileSettingsTooltip,
                      color: 'transparent',
                      direction: 'right',
                      config: {
                        text: this.$t('administration/partner.select_country_first')
                      }
                    },
                    autocomplete_options: {
                      module: 'base',
                      route: `countries/${this.formCitiesData.countryId}/cities/autocomplete`,
                      fetchInitial: false,
                      // remove previously set form cities data
                      onDataReceive: () => {
                        this.$set(this.formCitiesData, 'data', [])
                      }
                    },
                    hasMore: this.formCitiesData.hasMore,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'geolocation',
                    label: this.$t('administration/partner.geolocation'),
                    placeholder: this.$t('administration/partner.select_location'),
                    append: {
                      src: '/img/icons/select-location-icon.svg'
                    },
                    readonly: true,
                    appendIconClick: (event) => this.showLocationsDialog(event),
                    onClick: (event) => this.showLocationsDialog(event),
                    clearErrorsOnValueChange: true,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'contact_point',
                    label: this.$t('administration/partner_location.contact_point'),
                    placeholder: this.$t('administration/partner_location.enter_contact_point'),
                    tooltip: {
                      text: this.$t('administration/partner_locations.contact_point_tooltip')
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    showLocationsDialog (event) {
      const coords = event?.formData?.geolocation?.replace(' ', '').split(',')
      const latitude = coords?.[0] || event?.formData?.geolocation?.lat
      const longitude = coords?.[1] || event?.formData?.geolocation?.lng

      this.$set(this.chooseLocationDialogConfig, 'title', this.$t('road-maintenance.excavation_modal_location_btn'))
      this.$set(this.chooseLocationDialogConfig, 'confirmText', this.$t('base.save'))
      this.$set(this.chooseLocationDialogConfig, 'event', event)
      this.$set(this.chooseLocationDialogConfig, 'markers', null)
      if (latitude && longitude) {
        this.$set(this.chooseLocationDialogConfig, 'markers', {
          lat: latitude,
          lng: longitude
        })
      }
      this.$set(this.chooseLocationDialogConfig, 'createMode', true)
      this.$set(this.chooseLocationDialogConfig, 'callback', (event) => this.onLocationSaveCallback(event))
      this.$set(this.chooseLocationDialogConfig, 'show', true)
    },

    onLocationSaveCallback (event) {
      const { coordinates } = event || {}
      const { updateData } = registeredTabsHandlers?.[TAB_KEY] || {}

      if (isFunction(updateData)) {
        updateData({
          geolocation: (coordinates?.lat || null) + ', ' + (coordinates?.lng || null)
        })
      }
      this.chooseLocationDialogConfig.show = false
    },

    onModifyDataBeforeSend (event) {
      const { copiedData } = event || {}
      if (copiedData) {
        const geolocationSplit = copiedData?.geolocation?.trim()?.replace(' ', '')?.split(',')
        copiedData.geolocation = {
          lat: geolocationSplit?.[0],
          lng: geolocationSplit?.[1]
        }
      }
      return copiedData
    },

    backToMainTable (refreshData = true) {
      // exit from create mode to main table
      this.createMode = false
      if (refreshData) {
        const { fetchData } = registeredTableHandlers?.partnerLocations || {}
        fetchData?.()
      }
    }
  }
}
